<form class="form" [formGroup]="feedbackForm" *ngIf="feedbackForm">
  <h3>{{ BOARD_STRINGS.FEEDBACK_CAPTION | translateString : lang }}</h3>
  <h4 *ngIf="organisationName">{{ FEEDBACK_FORM_STRINGS.SUBHEADING | translateString : lang : organisationName }}</h4>
  <ui-input-select
    label="{{ FEEDBACK_FORM_STRINGS.MESSAGE_TYPE | translateString : lang }}"
    formControlName="messageType"
    [options]="messageTypes"
    width="100%"
    labelSuffix="*"
    required="true"
  ></ui-input-select>
  <ui-input-text
    label="{{ FEEDBACK_FORM_STRINGS.SUBJECT_TITLE | translateString : lang }}"
    formControlName="subject"
    width="100%"
  ></ui-input-text>
  <ui-input-textarea
    label="{{ FEEDBACK_FORM_STRINGS.MESSAGE_TITLE | translateString : lang }}"
    formControlName="message"
    rows="3"
    lengthHint="1000"
    width="100%"
    labelSuffix="*"
    required="true"
    [errorsMessages]="{
      required: FEEDBACK_FORM_STRINGS.MESSAGE_ERROR_REQUIRED | translateString : lang,
      maxlength: FEEDBACK_FORM_STRINGS.MESSAGE_ERROR_LENGTH_EXCEEDED | translateString : lang
    }"
  ></ui-input-textarea>
  <ui-input-text
    label="{{ GLOBAL_STRINGS.NAME | translateString : lang }}"
    formControlName="name"
    width="100%"
    labelSuffix="*"
    required="true"
    [errorsMessages]="{
      name: FEEDBACK_FORM_STRINGS.NAME_ERROR_REQUIRED | translateString : lang,
      required: FEEDBACK_FORM_STRINGS.NAME_ERROR_REQUIRED | translateString : lang
    }"
  ></ui-input-text>
  <ui-input-text
    label="{{ FEEDBACK_FORM_STRINGS.EMAIL_TITLE | translateString : lang }}"
    formControlName="email"
    width="100%"
    labelSuffix="*"
    required="true"
    [errorsMessages]="{
      required: FEEDBACK_FORM_STRINGS.EMAIL_ERROR_REQUIRED | translateString : lang,
      pattern: FEEDBACK_FORM_STRINGS.EMAIL_ERROR_MALFORMED | translateString : lang
    }"
  ></ui-input-text>
  <div class="privacy-policy" *ngIf="privacyNotice">
    <ui-input-checkbox formControlName="privacyAgreement" [errorsMessages]="{ required: '' }" required="true">
      <div [innerHtml]="privacyNotice" [label] class="privacy-notice rich-text-format"></div>
    </ui-input-checkbox>
  </div>
  <div class="action-row">
    <span class="notification" [ngClass]="{ 'notification-error': hasSendError }" role="alert" aria-atomic="true">
      {{ notification }}
    </span>
    <h6 *ngIf="feedbackForm.valid" class="sr-only" role="alert" aria-atomic="true">
      {{ FEEDBACK_FORM_STRINGS.ENABLED_ANNOUNCEMENT | translateString : lang }}
    </h6>
    <app-button [aria]="{ atomic: true }" [disabled]="!feedbackForm.valid" [role]="'alert'" (buttonClicked)="send()">
      {{ sendCaption }}
    </app-button>
  </div>
</form>
